import AuthServices from "@/services/authServices";
import FBTrackingService from "@/services/fbTrackingService";
import { getGlobalSessionId } from "@/services";
import { User } from "@/types";
import { create } from "zustand";

interface UserState {
  userProfile: User | null;
  loading: boolean;
  getUserProfile: () => Promise<User | null>;
  isFreePlan: boolean;
}

const useUserStore = create<UserState>((set) => ({
  userProfile: null,
  loading: false,
  isFreePlan: true,
  getUserProfile: async (): Promise<User | null> => {
    // Don't make API call if no session exists (defense in depth)
    if (!getGlobalSessionId()) {
      return null;
    }
    set({ loading: true });
    const response = await AuthServices.getUserProfile();
    if (response.success) {
      const { plan, isPayAsYouGo, ipaSubscription } = response.data;
      const isFreePlan =
        (!plan?.active && !isPayAsYouGo) ||
        (!!ipaSubscription?.productId && !plan?.active);
      set({
        userProfile: response.data,
        isFreePlan: isFreePlan,
        loading: false,
      });

      // Identify user in analytics platforms
      if (response.data?.id) {
        FBTrackingService.setUserId(response.data.id);
      }

      FBTrackingService.setUserInfo({
        email: response.data?.email,
      });
      return response.data;
    }
    set({ loading: false });
    return null;
  },
}));

export default useUserStore;
